import { constructAuthenticatedRoute } from '~/core/shared/utils/routing';

export const APPLICATION_DOCUMENT_BASE_URL = '/document';

export const APPLICATION_DOCUMENT_ROUTES = {
  workflowStep: constructAuthenticatedRoute(
    `${APPLICATION_DOCUMENT_BASE_URL}/:document/workflow/:workflow`,
    'Workflow',
  ),
  workflowStepPlace: constructAuthenticatedRoute(
    `${APPLICATION_DOCUMENT_BASE_URL}/:document/workflow/:workflow/place/:place`,
    'Workflow step',
  ),
} as const;
